import _axios from 'axios'
import cfg from './../config.js'

/*eslint-disable*/

let http = ({method, url}) => {
  return _axios[method](`${cfg.baseURL}/${url}`)
  .catch(function (error) {
    console.log(error);
  });
}

let api = {
  getDataForSoundMap: () => http({
    method: 'get',
    url: 'api/soundmap'
  }),
  getCompanies: () => http({
    method: 'get',
    url: 'api/companies'
  }),
  getCompany: (id) => http({
    method: 'get',
    url: `api/company/${id}`
  }),
  getPrograms: () => http({
    method: 'get',
    url: `api/programs`
  }),
  getDocs: () => http({
    method: 'get',
    url: `api/od-docs`
  }),
  getTeam: () => http({
    method: 'get',
    url: 'api/team'
  }),
  getOdNews: () => http({
    method: 'get',
    url: 'api/news-opendays'
  })
}
export default api
